<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>英文校正​</h1>
                            <h2>英文校正を<br/>Trinkaで<br/>もっとシンプルに</h2>
                            <p>英文校正を自分でするならTrinka（トリンカ）。AI搭載の英文校正機能で誤りのない英語の文章に。ワンクリックで文法やスペルミスを修正し、文章構成、句読点、トーン、一貫性などを改善できます。</p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" class="filled-btn" target="_blank">さっそく始める</a>
                            </div>
                            <span class="no-credits-tools">クレジットカード不要</span>
                        </div>
                        <div class="top-banner-right">
                            <img src="assets/images/proofreading.png" alt="英文校正">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- <div class="cloud_top_banners">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-xl-7">
                    <div class="trinka_cloud_banner_text">
                        <h1 class="yellow-header">Free Online Proofreader</h1>
                        <h2>English Proofreading Made Easy With Trinka AI</h2>
                        <p>Make your writing flawless with our AI-powered English Proofreading Tool. Correct grammar, spelling errors, sentence structure, punctuation, tone, consistency, and much more with a single click!</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" id="autoEditGetStart" target="_blank">Get Started</a>
                        <span class="no-credits-tools">No credit card required</span>
                    </div>
                </div>
                <div class="col-xl-5">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/proofreading.png" alt="proofreader banner">
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="brandLogo_sections mt-0">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="brandlogo_heading">
                        <h2>世界の著名な大学の皆様にご利用いただいています</h2>
                    </div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client_inners">
                                    <img src="assets/images/MIT.jpg" alt="MIT - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/StanfordUniversity.jpg" alt="Stanford University - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/HarvardMedicalSchool.jpg" alt="Harvard Medical School - 英文校正 ai">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/Caltech.jpg" alt="Caltech university - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/UCL.jpg" alt="UCL - 英文チ ェッカー">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client_inners">
                                    <img src="assets/images/ImperialCollegeLondon.jpg" alt="Imperial College London - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/UniversityOfManchester.jpg" alt="University of Manchester - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/Duke.jpg" alt="duke universities - 英文校正">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/PrincetonUniversity.jpg" alt="Princeton University - 文法 チェック">
                                </div>
                            </div>
    
                        </div>
                    </div>
                    <!-- <div class="viewfullList">
                        <a routerLink="/brand-list">Trinkaを使う大学・研究機関</a>
                    </div> -->
                </div>
            </div>
        </div>
    </div>

    <div class="the_best_grammer_sections section-pd">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>高精度の英文校正を、無料で</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>文法やスペルから文章構成、トーンまで、Trinkaは英語の文書の精度を様々な角度から向上させます。AI搭載の英文校正機能が、文法、スペル、句読点などの問題点を知らせてくれるため、より全体的なメッセージに気を配った英文ライティングが可能になります。
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="howItWorks section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/yt-thumbnail/AutoFileEditThumbnail.webp" alt="自動ファイル編集 - 英文校正" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2">
                        <div class="trinka-title mb-0">
                            <h2>使い方</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>Trinkaの使い方は簡単。解説動画をご覧ください。</p>
                            <p>ご不明点については、<a style="color: #0000ff;" (click)="scroll(target)" class="link text-link">よくある質問</a>もご参照ください。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>Trinkaの英文校正はこんな方におすすめ</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <h3>研究者</h3>
                        <p>
                            Trinkaは学術論文、学位論文、研究論文の英文校正・英文校閲において真価を発揮します。学術的な整合性を維持しながら、概念や事実を正確に伝えます。
                        </p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <h3>ビジネスパーソン</h3>
                        <p>
                            報告書やプレゼンテーションから、Eメールまで、Trinkaは仕事関係の英文校正にも役立ちます。洗練された英文で、国内外のビジネスも円滑に。
                        </p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <h3>学生</h3>
                        <p>
                            レポートなどの課題を含む提出物から、論文、願書や申請書まで、幅広い学術関連文書の英語を校正します。                       
                        </p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <h3>英文でのライティングが必要な全ての方</h3>
                        <p>
                            Trinkaは幅広いタイプの英文に対応。自己PRやカバーレター、ストーリー、ソーシャルメディアへの投稿などを英文校正し、メッセージを効果的に伝えます。
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="the_best_grammer_sections section-pd pt-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>英文校正の機能​</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>短時間で英文校正とライティングの質の査定ができるTrinkaには、研究者をはじめとした幅広い分野の人々をサポートする機能が備わっています。​</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="best_grammer_cards">
                        <h3>高度な文法チェック</h3>
                        <div class="content_body_best_grammer">
                            <div class="best_content_text">
                                <p>英文に見つかりにくい文法ミスがないかを評価して、文章の質を向上させるための英文校正を提案します。​</p>
                            </div>
                            <div class="mini_card_grammer">
                                <!-- <h4>Technical word choice</h4> -->
                                <p>Neither the healthy individuals nor the patient <span
                                    class="wrong_text">recognize</span> <span
                                    class="right_text"> recognizes</span> the visual discrepancies.</p>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col-lg-6">
                    <div class="best_grammer_cards">
                        <h3>文章構成</h3>
                        <div class="content_body_best_grammer">
                            <div class="best_content_text">
                                <p>分野や文書の種類に則った文章構成にして、読み手にとって分かりやすい英文にします。</p>
                            </div>
                            <div class="mini_card_grammer">
                                <!-- <h4>Syntax</h4> -->
                                <p>The students don't enjoy <span class="wrong_text">to go</span> <span
                                    class="right_text"> going</span> over the same rules again and again.</p>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col-lg-6">
                    <div class="best_grammer_cards">
                        <h3>単語の選択</h3>
                        <div class="content_body_best_grammer">
                            <div class="best_content_text">
                                <p>英文の意味をあいまいにする単語を特定し、より適切な単語に置き換えます。</p>
                            </div>
                            <div class="mini_card_grammer">
                                <!-- <h4>Advance Spelling</h4> -->
                                <p>One of the reasons is <span class="wrong_text">because</span> <span
                                    class="right_text"> that</span> the fabrication cost <span
                                    class="wrong_text">for</span> <span class="right_text"> of</span> steel
                                members depends upon the material.</p>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col-lg-6">
                    <div class="best_grammer_cards">
                        <h3>高度なスペルチェック</h3>
                        <div class="content_body_best_grammer">
                            <div class="best_content_text">
                                <p>文脈を理解し、トピックに即した正しいスペルを提案します。</p>
                            </div>
                            <div class="mini_card_grammer">
                                <!-- <h4>Sensitive language</h4> -->
                                <p>The <span class="wrong_text">Bonferoni</span> <span
                                    class="right_text"> Bonferroni</span> test was used to check for
                                statistical significance.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app section-pd-sm">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title mb-0 text-center">
                        <h3 class="text-white">アプリでもクラウドでも英文校正ができるTrinka</h3>
                    </div>
                    <div class="use_trinka_content">
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a>
                                        <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="無料の文法チェッカーツール">
                                            <h3>Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a>
                                        <div class="app_name_content" [routerLink]="['/wordplugin']">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/wordAdd-in1.svg" alt="word - 文法 チェック">
                                            <h3>MS Word</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a>
                                        <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/NewChromeIcon.svg" alt="chrome - 文法 チェック">
                                            <h3>Chrome</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a>
                                        <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/NewFirefoxIcon.svg" alt="firefox - 文法 チェック">
                                            <h3>Firefox</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a>
                                        <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="edge - 文法 チェック">
                                            <h3>Edge</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a>
                                        <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                            <span class="safariComingSoonTag">Coming Soon</span>
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/safari_logo.png" alt="safari - 文法 チェック">
                                            <h3>Safari</h3>
                                        </div>
                                    </a>
                                </li>
    
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="testimonial-section text-center section-pd">
        <app-testimonial></app-testimonial>
    </div>
    
    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h3 class="text-white mb-4">お試しになってみませんか？</h3>
                        <div class="btn-group justify-content-center">
                            <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="white-btn" id="grammerSignUpButton">
                                <!-- <i class="fa fa-sign-in"></i> -->
                                <span>無料登録する</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    </div> 

    <div class="faqQuestionAnwser section-pd" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-12 col-md-12">
                    <div class="trinka-title text-center">
                        <h2>よくあるご質問</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            英文校正ツールとは何ですか？</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <p>英文校正ツールは、英語の文章のスペルや文法、句読点の誤りを修正し、正しい英文に校正・校閲するためのツールです。自動で英文校正できるため、英語がネイティブでない書き手にとって、英文での執筆・ライティングを効果的に行うための強い味方です。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">
                                            Trinkaがあれば、プロの英文校正者に見てもらう必要はないですか？</a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>元の英文の質次第です。英語ネイティブでなく、細かなニュアンスレベルでの語感をお持ちでない方であれば、プロの英文校正者に最終チェックしてもらうことをおすすめします。Trinkaは何千ものパターンの文法ミスやライティングの問題を修正できますが、元の英文の構成に大きな問題があれば、書き手の意図に即した英文校正・英文校閲をすることが難しくなります。
                                            </p>
                                            <p>一方、論理的に正しい英文を書くことのできる英語ネイティブスピーカーなどの場合、Trinkaの英文校正だけで十分な質に仕上げられるはずです。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent">Trinkaはどんなプラットフォームやアプリで使えますか？</a>
                                    </div>
        
                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinkaは、Chrome、Firefox、Edge、Safari（近日公開）といったブラウザのプラグインとしてもご利用いただけます。また、プレミアムプラン及び上位プランのユーザーの皆様はMS Wordのアドインでもご利用いただけます。</p>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
    
                                <div class="card">
                                    <div class="card-header" id="QuestionGCFive ">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCFiveContent" aria-expanded="true"
                                            aria-controls="QuestionGCFiveContent">オンラインで、無料で英文チェックするにはどうすればよいですか？</a>
                                    </div>
        
                                    <div id="QuestionGCFiveContent" class="collapse"
                                        aria-labelledby="QuestionGCFive" data-parent="#faq">
                                        <div class="card-body">
                                            <p>まずは、ベーシックプランでご登録ください。お使いのブラウザから Trinka Cloudにアクセスすれば、1か月5000単語までクラウド上で英文校正機能を無料でお使いいただけます。クラウド上にファイルを保存できるから、修正の続きも簡単です。
                                            </p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionGCSix">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                            data-target="#QuestionGCSixContent" aria-expanded="true"
                                            aria-controls="QuestionGCSixContent">英語の文法的な正しさをチェックするには？</a>
                                    </div>
        
                                    <div id="QuestionGCSixContent" class="collapse"
                                        aria-labelledby="QuestionGCSix" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinkaに英文を貼り付けるだけで、文法的な正しさを自動でチェックします。文法のほか、句読点、語彙の間違いがないかなども英文校正し、修正案を提示します。</p>
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/6Z_PsveCtRQ"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>